import { createWeb3JsTransactionFactory } from './createWeb3JsTransactionFactory.mjs';

const web3JsTransactionFactory = () => ({
  install(umi) {
    umi.transactions = createWeb3JsTransactionFactory();
  }
});

export { web3JsTransactionFactory };
//# sourceMappingURL=plugin.mjs.map
